

































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import DataTableWithDialog from '@/components/DataTableWithDialog.vue';
import { mapModelLike } from '@/store/util';

import { reversedEnum, translatedEnumOptions } from '@/i18n';
import { AmmoFeedType, DamageType } from '@/model';
import { Prop } from 'vue-property-decorator';
import { WeaponMode } from '@/store/RangedWeaponsStore';

@Component({
  components: { DataTableWithDialog },
  computed: mapModelLike('rangedWeapons', ['items']),
})
export default class RangedWeaponsBox extends Vue {
  @Prop(Boolean) readonly editMode: boolean | undefined;

  static defaultHeight = 5;

  static optional = true;

  damageTypes = translatedEnumOptions(DamageType, 'weapons.damageTypes');

  ammoFeedTypes = translatedEnumOptions(AmmoFeedType, 'rangedWeapons.ammoFeedTypes');

  displayDamage(weapon: any) {
    const damageMnemo = this.$t(`weapons.damageTypes.${reversedEnum(DamageType)[weapon.damageType]}`).toString()[0];
    return `${weapon.damageValue}${damageMnemo}`;
  }

  displayAmmo(weapon: any) {
    const ammoFeedTypeMnemo = this.$t(`rangedWeapons.ammoFeedTypeMnemonics.${reversedEnum(AmmoFeedType)[weapon.ammoFeedType]}`).toString()[0];
    return `${weapon.ammoCount}${ammoFeedTypeMnemo}`;
  }

  translatedModes(modes: WeaponMode[]): any[] {
    return modes.map((mode) => ({ value: mode, text: this.$i18n.t(`rangedWeapons.modes.${mode}`) }));
  }

  updateCurrentWeaponMode(item: any, value: WeaponMode) {
    this.$store.commit('rangedWeapons/updateItem',
      { id: item.id, data: { ...item, currentMode: value } });
  }

  // eslint-disable-next-line class-methods-use-this
  enableSSForSA(item: any) {
    if (item.modes.indexOf(WeaponMode.SS) === -1 && item.modes.indexOf(WeaponMode.SA) === -1) {
      item.modes.push(WeaponMode.SS);
    }
  }

  get headers() {
    return [{
      text: this.$t('name'),
      align: 'start',
      sortable: true,
      value: 'name',
    }, {
      text: this.$t('weapons.damage'),
      align: 'start',
      sortable: false,
      value: 'damage',
    }, {
      text: this.$t('rangedWeapons.mode'),
      align: 'start',
      sortable: false,
      value: 'modes',
    }, {
      text: this.$t('rangedWeapons.ranges.close'),
      align: 'end',
      sortable: false,
      value: 'close',
    }, {
      text: this.$t('rangedWeapons.ranges.near'),
      align: 'end',
      sortable: false,
      value: 'near',
    }, {
      text: this.$t('rangedWeapons.ranges.medium'),
      align: 'end',
      sortable: false,
      value: 'medium',
    }, {
      text: this.$t('rangedWeapons.ranges.far'),
      align: 'end',
      sortable: false,
      value: 'far',
    }, {
      text: this.$t('rangedWeapons.ranges.extreme'),
      align: 'end',
      sortable: false,
      value: 'extreme',
    }, {
      text: this.$t('rangedWeapons.ammo'),
      align: 'end',
      sortable: false,
      value: 'ammo',
    },
    ];
  }
}
